


export const baseUrl='https://socialpshycho.onrender.com'